import React, { useContext } from 'react';
import ReferralDocumentList from './ReferralDocumentList';
import { DocumentUtils } from '../../../services';
import { Context } from '../../../store/AppStore';
import { useHistory } from 'react-router-dom';

export default function ReferralDocuments({ referral, patientId }) {

  const history = useHistory()
  const dispatch = useContext(Context)[1];

  const handleDocument = async (data) => {
    if( data ) {
      dispatch({ type: 'UPDATE_DOCUMENT_DATA', payload: data})
      history.push(`/patient/${patientId}/file/${data.document.id}/${data.iconName || 'file-alt'}`)
    }
  }
  return (
    <>
      <h1 style={{
        marginTop: '20px',
        marginBottom: '10px',
        fontSize: '18px',
        fontWeight: 'bold',
      }}>
        Referral Documents
      </h1>
      <ReferralDocumentList
        data={
          referral.linkedDocuments.map(
            document => DocumentUtils.getDisplayInfo(document)
          )
        }
        showDocument={handleDocument}
      />
    </>
  );
}
